'use client';

import { useRef, useState } from 'react';
import type { ComponentType } from 'react';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import type { NewsletterDialogRuntimeProps } from './newsletter-dialog-runtime';

export function NewsletterDialog() {
  const { t } = useTranslations();
  const trigger = useRef<HTMLButtonElement>(null);
  const loading = useRef(false);
  const [Runtime, setRuntime] = useState<ComponentType<NewsletterDialogRuntimeProps> | null>(null);
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(false);
  const [failed, setFailed] = useState(false);

  async function openOffer() {
    if (Runtime) {
      setOpen(true);
      return;
    }
    if (loading.current) return;
    loading.current = true;
    setPending(true);
    setFailed(false);
    try {
      const loaded = await import('./newsletter-dialog-runtime');
      setRuntime(() => loaded.NewsletterDialogRuntime);
      setOpen(true);
    } catch {
      setFailed(true);
    } finally {
      loading.current = false;
      setPending(false);
    }
  }

  return (
    <>
      <button
        ref={trigger}
        type="button"
        onClick={openOffer}
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-busy={pending}
        aria-disabled={pending}
        className="fixed bottom-[calc(max(8px,env(safe-area-inset-bottom))+4px)] left-1/2 z-[40] h-8 max-w-[calc(100%-8rem)] -translate-x-1/2 truncate rounded-full border border-primary bg-white px-3 py-1 text-[11px] font-medium text-primary shadow-sm transition-colors hover:bg-primary/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary sm:bottom-48 sm:left-auto sm:right-4 sm:h-auto sm:max-w-[12rem] sm:translate-x-0 sm:overflow-visible sm:whitespace-normal sm:rounded-2xl sm:px-4 sm:py-3 sm:text-sm"
      >
        {failed ? t('text595') : t('text3969')}
      </button>
      {/* Never mount the form, image or mutation observer during the initial page load. */}
      {Runtime && (
        <Runtime
          open={open}
          onOpenChange={setOpen}
          onReturnFocus={() => trigger.current?.focus()}
        />
      )}
    </>
  );
}
